const dataCenterMappings = {
    us: [
        '(development)',
        'dallas',
        'dev-aws',
        'lynnwood',
        'rqa3',
        'sea',
        'seapr1',
        'us',
    ],
    emea: [
        'amsdr1',
        'amsterdam',
        'emea',
        'par',
        'parim1',
        'paris',
        'parpr1',
        'rqa5',
    ],
    china: [
        'beijing',
        'beipr1',
        'china',
        'cn',
    ],
    public_sector: [
        'pscc',
        'public_sector',
        'uspscc',
    ],
};

export const getAllDataCenterLocations = () => {
    let locations = [];
    const dataCenters = Object.keys(dataCenterMappings);

    for (let i = 0; i < dataCenters.length; i += 1) {
        locations = [...locations, ...dataCenterMappings[dataCenters[i]]];
    }

    return locations;
};

export const getDataCenter = (location) => {
    const dataCenterLocation = (location || '').toLowerCase();
    const dataCenters = Object.keys(dataCenterMappings);

    for (let i = 0; i < dataCenters.length; i += 1) {
        if (dataCenterMappings[dataCenters[i]].some((element) => element === dataCenterLocation)) {
            return dataCenters[i];
        }
    }

    return '';
};
